.modal-title {
    font-weight: 500;
    color: var(--grey-dk);
    font-size: var(--font-normal);
    line-height: 1.5;
    margin-bottom: 12px;
}

.modal-title--less-bottom-margin {
    margin-bottom: 2px;
}
